<template>
  <span class="h-money" :class="{ 'h-money--muted': isEmpty }">{{ formatted }}</span>
</template>

<script>
// Money value — right-aligned, tabular-nums, mono, currency-formatted.
// Per DESIGN.md: money is always right-aligned, tabular, mono, with its
// currency symbol (GBP `£` by default). Null/blank renders an em-dash.
export default {
  name: 'HermesMoneyCell',
  props: {
    // Major-unit amount (e.g. 49.00). Strings are parsed.
    amount: { type: [Number, String], default: null },
    // ISO 4217 code. Null renders a plain grouped number (no symbol).
    currency: { type: String, default: 'GBP' },
    // Locale override; undefined = the browser default.
    locale: { type: String, default: undefined },
  },
  computed: {
    isEmpty() {
      if (this.amount === null || this.amount === undefined || this.amount === '') return true;
      return Number.isNaN(parseFloat(this.amount));
    },
    formatted() {
      if (this.isEmpty) return '—';
      const value = parseFloat(this.amount);
      if (!this.currency) {
        return new Intl.NumberFormat(this.locale, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }).format(value);
      }
      try {
        return new Intl.NumberFormat(this.locale, {
          style: 'currency',
          currency: this.currency,
        }).format(value);
      } catch (e) {
        // Unknown ISO code — show plainly rather than throw.
        return `${value.toFixed(2)} ${this.currency}`;
      }
    },
  },
};
</script>

<style scoped>
.h-money {
  font-family: var(--h-font-mono, monospace);
  font-variant-numeric: tabular-nums;
  font-size: 13.5px;
  font-weight: 500;
  color: var(--h-text-primary, #0F172A);
  text-align: right;
  display: inline-block;
  white-space: nowrap;
}
.h-money--muted { color: var(--h-text-tertiary, #94A3B8); }
</style>
